import { ActionReducer, Action } from "@ngrx/store";

export function mergeReducers<TState>(...reducers: ActionReducer<TState, Action>[]): ActionReducer<TState, Action> {
	const mergedReducers = (
		state: TState | undefined,
		action: Action
	): TState => {
		if (reducers.length === 0) {
			throw new Error('At least one reducer was expected');
		}
		const newState = reducers.reduce((initialState, reducer) => {
			const intermediaryState = reducer(initialState, action);
			return intermediaryState;
		}, state);

		return newState as TState;
	};
	return mergedReducers;
}